import React from 'react';
import LegalPageLayout from '../components/LegalPageLayout';
import { AlertTriangle, PhoneCall, Timer, Wallet, Users, HeartHandshake } from 'lucide-react';

export default function ResponsibleGamblingPage() {
  const sections = [
    {
      title: 'Our commitment',
      paragraphs: [
        'Sports betting can be an entertaining pastime, but for some people it becomes a source of stress, financial hardship, and family harm. Top 3 Football Tipsters is built for adults who bet for pleasure and within their means. We take our duty of care seriously: no tip we publish is worth more than your long-term wellbeing.'
      ]
    },
    {
      title: 'Bet for entertainment, never to make a living',
      paragraphs: [
        'Even the sharpest professional loses a large percentage of the time. Winning streaks feel great, losing streaks are painful, and both are inevitable. Treat any money you stake as the price of an evening’s entertainment. If a losing week would materially affect your rent, groceries, or family life, please do not place the bet.'
      ]
    },
    {
      title: 'Set clear personal limits',
      bullets: [
        'Decide, before you start each month, the maximum amount you are willing to lose. Once it is gone, stop — no exceptions.',
        'Set a time budget too. It is very easy to spend hours checking live scores; put a firm end-time on every betting session.',
        'Never chase losses. Doubling stakes to “recover” money almost always leads to bigger losses and worse decisions.',
        'Never gamble under emotional distress, alcohol, or any other influence that affects judgement.'
      ]
    },
    {
      title: 'Warning signs',
      paragraphs: [
        'If any of the following applies to you, please pause and consider seeking support:'
      ],
      bullets: [
        'You spend more time or money on betting than you originally planned.',
        'You feel restless or irritable when you try to bet less or stop.',
        'You borrow money, sell possessions, or miss bills to fund bets.',
        'You hide the extent of your gambling from family, friends, or your partner.',
        'You bet to escape negative feelings such as anxiety, boredom, guilt, or depression.',
        'A significant relationship, job, or opportunity is being affected by your betting.'
      ]
    },
    {
      title: 'Practical tools we offer',
      bullets: [
        'Self-exclusion — email premiumtipsters@tip1x2bet.com to close your account for a period of your choosing (30 days, 6 months, 1 year, or permanent). Any remaining subscription value will be refunded in full.',
        'Cooling-off — pause your subscription for up to 30 days without cancelling it, so you can step away without losing your access when you return.',
        'Deposit-limit reminder — we can send you an email reminder at the start of each month to help you stick to a self-set budget.',
        'Reality-check emails — opt in to a monthly summary of your subscription spend so nothing is hidden or forgotten.'
      ]
    },
    {
      title: 'Get free, confidential help',
      paragraphs: [
        'You are not alone — professional, confidential support is available in most countries free of charge. Some well-established resources include:'
      ],
      bullets: [
        'GamCare (United Kingdom) — gamcare.org.uk — free helpline, live chat, and one-to-one support.',
        'BeGambleAware (United Kingdom) — begambleaware.org — information, advice, and referral to treatment.',
        'Gambling Therapy (international) — gamblingtherapy.org — free online support in multiple languages.',
        'Gamblers Anonymous — gamblersanonymous.org — peer-support fellowship active in over 50 countries.',
        'National Council on Problem Gambling (US) — ncpgambling.org — 24/7 confidential helpline: 1-800-GAMBLER.'
      ]
    },
    {
      title: 'Under-18s are strictly excluded',
      paragraphs: [
        'Sports-betting products, including any subscription we sell, are for adults only. Anyone found to be under the legal age of majority in their country will be immediately excluded from the Service and any remaining balance forfeited. If a child in your household has access to your device, please make sure the Tip1x2 site cannot be used without your consent.'
      ]
    },
    {
      title: 'Family and friends',
      paragraphs: [
        'If you are worried about someone else’s gambling, please do not stay silent. Speak to them calmly, without judgement. Encourage them to contact one of the organisations listed above. You can also reach out to us at premiumtipsters@tip1x2bet.com and we will help you initiate a self-exclusion on their behalf where appropriate.'
      ]
    },
    {
      title: 'Contact',
      paragraphs: [
        'Any request relating to responsible gambling — self-exclusion, cooling-off, deposit-limit reminders, or refund of a paused subscription — should be sent to premiumtipsters@tip1x2bet.com. Every message is handled discreetly and with priority.'
      ]
    }
  ];

  return (
    <LegalPageLayout
      title="Responsible Gambling"
      updated="June 2026"
      intro="Bet only what you can afford to lose. If it stops being fun, stop — and reach out for help. This page explains how we support safer gambling and where to find free, confidential support."
      sections={sections}
    />
  );
}
